import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";
import { EducatorInterface } from "../interfaces/EducatorInterface";

export const educatorApiSlice = createApi({
    reducerPath: "educatorApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getEducators: builder.query<
            {
                data: EducatorInterface[];
                meta: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                sort?: string;
                filter?: {
                    qualification_id?: number;
                };
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.EDUCATOR}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export default educatorApiSlice.reducer;

export const { useGetEducatorsQuery } = educatorApiSlice;
